var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilderStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #161617;\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #161617;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 22.3px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #f7cc11;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 250.5,
    cy: 250,
    r: 214.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.9,352.3l-26.1-87h6.8l39.4,86.9h-20.1ZM353,265.3v-34.4h-28.3c-4.8.4-5.7-3.3-3.7-6.4l18.1-21.2-.5-.5h-9.8c-3.5.5-4.9-3.3-2.7-6l19.6-23h-5.7c-3.6,0-4.4-3.2-2.2-6.3l17.8-21.1c1.2-1.4,2.4-3.6,4.6-3.5s2.9,1.8,4,3l18.9,22c1.3,1.5,1.2,3.9-.4,5.2-.8.7-1.8,1-2.9.9h-5.1l19.4,22.8c1.6,1.4,1.7,3.8.3,5.4-.5.5-1.1.9-1.8,1.1h-11.3l16.9,19.8,1.9,2.2c1.2,1.6.8,3.9-.8,5-.5.4-1.1.6-1.6.7h-30.4v34.4h34.3v17.6h-65.6l-7.3-17.6h24.3ZM141.6,253.5v8.7h-3.6v-2.8h.8v-6h2.8ZM120.9,243.2c-1.2.3-2.4.5-3.6.6-2.6.2-5.3-.4-7.6-1.8-2.3-1.4-4.1-3.4-5.2-5.8-1.9-4.8-2-10.2-.2-15.1-2.5-3.5-3.7-7.7-3.3-12,.4-3.1,1.8-6.1,4-8.4,2.3-2.4,5.3-4.2,8.5-5.1,6.4-1.7,13.2-1.1,19.2,1.8.7-.6,1.5-1.1,2.2-1.6,3.7-2.7,8.3-3.9,12.9-3.3,5,1,9.5,3.9,12.5,8,.9,1,1.7,2.1,2.4,3.2,4.1-.2,8.1.9,11.5,3.1,1.8,1.3,3.2,3,3.9,5.1.7,2.1.7,4.4,0,6.4-1.4,3.7-4,6.8-7.3,8.8-.2,3.2-1.1,6.4-2.7,9.3-1.2,2.1-2.9,3.8-5.1,4.9-2.2,1-4.7,1.1-6.9.3-.8-.2-1.5-.6-2.2-.9l-1.4,3.4c-3.6,8.4-4.9,11.3-5.3,21h32.6l-7.3,17.6h-71.8v-17.6h28.8c-.1-9.2-.9-10.4-5.3-17-.9-1.4-2-3.1-3.3-5.1h0ZM123.5,242.2l3,4.6c4.9,7.2,5.6,8.5,5.8,18.5h12.2c.4-10.3,1.8-13.4,5.5-22l1.6-3.8c-.3-.2-.6-.5-.9-.8-.6.6-1.2,1.2-1.8,1.7-2.3,2.1-5.4,3.3-8.6,3.3-3.2-.2-6.1-1.6-8.4-3.7-.7-.6-1.4-1.3-2.1-2-1.9,1.8-4,3.2-6.4,4.3h0ZM131.8,242.8l5.6,9.3-2.4,1.4-5.6-9.3s2.4-1.4,2.4-1.4ZM198.7,352.2l16.3-87h-8.1l-26,87h17.8ZM172.4,352.2l26-87h-6.8l-39.4,87h20.1ZM256.8,352.2v-87h8.1l8.3,87h-16.3ZM282,352.2l-9-87h8.2l17.1,87h-16.3ZM306.5,352.2l-16.3-87h8l26,87h-17.8ZM248.4,352.2v-87h-8.1l-8.2,87h16.3ZM223.2,352.2l9-87h-8.2l-17.1,87h16.3ZM100.7,325.7h52.4l-12,26.5h-40.4v-26.5ZM355.5,325.7h46.3v26.5h-34.3l-12-26.5ZM100.7,295.3h66.1l-8.2,18h-58v-18ZM341.7,295.3h60v18h-51.9s-8.1-18-8.1-18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "174.9 265.3 95.8 265.3 95.8 282.8 167.6 282.8 174.9 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "95.8 325.7 95.8 352.2 136.1 352.2 148.2 325.7 95.8 325.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "161.9 295.2 95.8 295.2 95.8 313.2 153.7 313.2 161.9 295.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "331.1 282.8 396.7 282.8 396.7 265.3 323.8 265.3 331.1 282.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "344.9 313.2 396.8 313.2 396.8 295.2 336.8 295.2 344.9 313.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "202 265.3 176 352.2 193.8 352.2 210.1 265.3 202 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.7 265.3 147.3 352.2 167.4 352.2 193.4 265.3 186.7 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "301.9 265.3 328 352.2 328 352.1 348.1 352.1 308.7 265.3 301.9 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "285.3 265.3 301.5 352.2 319.4 352.2 293.3 265.3 285.3 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.1 265.3 201.9 352.2 218.3 352.2 227.3 265.3 219.1 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "362.6 352.2 396.9 352.2 396.9 325.7 350.5 325.7 362.6 352.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "235.4 265.3 227.2 352.2 243.5 352.2 243.5 265.3 235.4 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "251.8 265.3 251.8 352.2 268.2 352.2 259.9 265.3 251.8 265.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "268.1 265.3 277 352.2 293.4 352.2 276.3 265.3 268.1 265.3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderStep2);
export default __webpack_public_path__ + "static/media/Builder-Step2.de096bc14f1c2e682ec8783fd3a61113.svg";
export { ForwardRef as ReactComponent };